<script setup>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import Helmet from '@/components/Helmet.vue';

const blogPosts = [
  {
    title: 'Mantenimiento web: por qué es clave para tu sitio y cómo hacerlo bien',
    summary:
    'Aprendé por qué el mantenimiento web regular es esencial para mantener tu sitio seguro, rápido y actualizado. Evitá errores, caídas y pérdidas de posicionamiento con estos consejos prácticos.',
    date: '9 de junio de 2025',
    link: '/blog/mantenimientoweb',
    image: '/img/mantenimiento.png'
  },
  {
    title: 'Cómo mejorar la presencia online de tu negocio o empresa para atraer más clientes y destacarte en internet',
    summary:
    'Descubrí estrategias clave para que tu emprendimiento, negocio local o empresa gane visibilidad en internet, atraiga más clientes y se destaque frente a la competencia.',
    date: '9 de junio de 2025',
    link: '/blog/presencia-online',
    image: '/img/presencia-online.png'
  },
  {
    title: 'Optimización web: cómo mejorar la velocidad y el posicionamiento de tu sitio',
    summary:
    'Conocé qué factores influyen en la velocidad de carga de una página web y cómo optimizarlos para mejorar tu posicionamiento en Google y ofrecer una mejor experiencia a tus usuarios.',
    date: '9 de junio de 2025',
    link: '/blog/optimizacion-posicionamiento',
    image: '/img/optimizacionweb.jpg'
  },
  {
    title: 'Por qué tu negocio necesita un sitio web profesional',
    summary:
      'Descubrí cómo una página web bien desarrollada puede ayudarte a captar más clientes, ganar confianza y posicionarte online.',
    date: '28 de mayo de 2025',
    link: '/blog/sitioweb-profesional',
    image: '/img/moderndesign.jpg'
  },
  {
    title: 'Diferencias entre una web hecha a medida y una con, Tienda Nube, Shopify o Wix',
    summary:
      'Exploramos las ventajas de una web 100% personalizada frente a soluciones prediseñadas. ¿Cuál conviene más a largo plazo?',
    date: '28 de mayo de 2025',
    link: '/blog/webprogramada-vs-constructores',
    image: '/img/codevsbuilder.png'
  },
  {
    title: 'SEO para emprendedores: cómo aparecer en Google',
    summary:
      'Una guía simple para entender cómo funciona el posicionamiento orgánico, y qué podés hacer desde hoy mismo.',
    date: '28 de mayo de 2025',
    link: '/blog/seo',
    image: '/img/seo.jpg'
  },
];

</script>

<template>
  <Helmet title="Blog de Desarrollo Web y Marketing Digital | Resi Corporation" />
  <Header />

  <section class="blog-container">
    <h1 class="title">Blog en español</h1>
    <p class="description">
      Tips, estrategias y consejos sobre desarrollo web, negocios online y marketing digital.
    </p>

    <div class="blog-grid">
      <div class="blog-card" v-for="(post, index) in blogPosts" :key="index">
        <h2>{{ post.title }}</h2>
        <p class="date">{{ post.date }}</p>
        <img :src="post.image" :alt="post.title" class="blog-card-image" />
        <!--<p class="summary">{{ post.summary }}</p>-->
        <router-link :to="post.link" class="read-more">Leer artículo</router-link>
    </div>
</div>

  </section>

  <Footer />
</template>

<style>
.blog-container {
  margin-top: 100px !important;
  max-width: 1200px;
  margin: 0 auto;
  padding: 4rem 1rem;
  text-align: center;
}

.title {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.description {
  font-size: 1.125rem;
  margin-bottom: 3rem;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
}

.blog-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
}

.blog-card {
  background-color: var(--body-color);
  border: 1px solid #ccc;
  border-radius: 12px;
  padding: 2rem;
  text-align: left;
  transition: transform 0.2s ease;
}

.blog-card:hover {
  transform: translateY(-5px);
}

.blog-card h2 {
  font-size: 1.25rem;
  margin-bottom: 0.5rem;
}

.blog-card .date {
  font-size: 0.85rem;
  color: var(--text-color);
  margin-bottom: 0.75rem;
}

.blog-card-image {
  padding: 10px 0;
}

.blog-card .summary {
  font-size: 0.95rem;
  margin-bottom: 1rem;
  line-height: 1.5;
}

.read-more {
  display: inline-block;
  color: var(--title-color);
  text-decoration: none;
  border: 1px solid currentColor;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-weight: bold;
  transition: background 0.2s ease;
}

.read-more:hover {
  background-color: var(--first-color);
}

.dark .blog-card {
  background-color: #1a1a1a;
  border-color: #444;
  color: #fff;
}

.dark .blog-card .date {
  color: #aaa;
}

.dark .read-more:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
</style>
